<template>
  <div class="whole">
    <div class="title">
      <div class="back iconfont iconfanhui" @click="test"></div>
      <p class="titleName">{{ title }}</p>
      <div
        class="search iconfont iconsousuo1"
        @click="$router.push('search')"
      ></div>
      <div
        class="gongge iconfont iconsigongge"
        @click="changesize()"
        v-if="!itemsize"
      ></div>
      <div
        class="gongge iconfont iconfenbupailie"
        @click="changesize()"
        v-if="itemsize"
      ></div>
    </div>
    <div class="body">
      <div v-if="hasList" class="search">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="search_content">
            <!-- <div
              class="item"
              v-for="items in goodsList"
              :class="itemsize ? 'item_big' : 'item_small'"
              :key="items.goods_id"
              @click="jump(items.goods_id)"
            > -->
            <div
              class="item"
              v-for="items in goodsList"
              :class="itemsize ? 'item_small' : 'item_big'"
              :key="items.goods_id"
              @click="jump(items.goods_id)"
            >
              <div class="img">
                <img
                  :src="items.image[0].file_path | thumbnail(720, 720)"
                  alt
                />
              </div>
              <div class="message">
                <div class="des" style="font-size:16px">
                  <p>{{ items.goods_name }}</p>
                  <p>产品编号：{{ items.goods_number }}</p>
                  <p>克重(g)：{{ items.sku[0].goods_weight }}</p>
                </div>
                <!-- <div class="price" style="font-size:14px;"></div> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="nosearch" v-if="!hasList">
        抱歉,没有搜索到关于
        <span>{{ searchKey }}</span
        >的产品
      </div>
    </div>
  </div>
</template>
<script>
import Tabbar from "@/components/Tabbar.vue";
import { getList } from "../../api/http.js";
import axios from "axios";
export default {
  data() {
    return {
      goodsList: [],
      title: "",
      searchKey:"",
      hasList: true,
      currentPage: 1,
      pagecount: 1,
      loading: false,
      finished: true,
      category_id: 0,
      itemsize: true,
      token: ""
    };
  },
  created() {
    this.token = localStorage.getItem("login_token");
    if (localStorage.getItem("getCategory_size") != null) {
      this.itemsize = Boolean(
        localStorage.getItem("getCategory_size") === "true"
      );
    }
    const search = this.$route.query.search || "";
    this.title = this.$route.query.tag;
    this.searchKey = this.$route.query.search;
    this.category_id = this.$route.query.categoryid || 0;
    this.searchresult = this.$route.query.search || "";
    this.init(this.category_id, search);
  },
  methods: {
    test() {
      this.$router.push("/search");
      this.itemsize = true;
      localStorage.removeItem("getCategory_size");
    },
    init(category_id, search) {
      getList(1, "all", true, category_id, search, this.token).then(res => {
        if (res.code == "1") {
          this.goodsList = res.data.list.data;
          this.currentPage = res.data.list.current_page;
          this.pagecount = res.data.list.last_page;
          if (res.data.list.data.length <= 0) {
            this.hasList = !this.hasList;
          }
          if (this.currentPage != this.pagecount) {
            this.finished = false;
          }
        }
      });
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    },
    onLoad() {
      setTimeout(() => {
        this.currentPage += 1;
        getList(
          this.currentPage,
          "all",
          true,
          0,
          this.searchresult,
          this.token
        ).then(res => {
          if (res.code == "1") {
            this.goodsList = this.goodsList.concat(res.data.list.data);
            this.currentPage = res.data.list.current_page;
            if (this.currentPage == this.pagecount) {
              this.finished = true;
            }
          }
          this.loading = false;
        });
        // this.loadList(this.category_id);
      }, 500);
    },
    changesize() {
      this.itemsize = !this.itemsize;
      localStorage.setItem("getCategory_size", this.itemsize);
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.whole {
  min-height: 100vh;
  background: #efefef;
  overflow: hidden;
  .title {
    width: 100%;
    position: fixed;
    height: 44px;
    background: #fff;
    text-align: center;
    z-index: 2;
    .back {
      position: absolute;
      top: 0px;
      left: 10px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
    .titleName {
      font-size: 14px;
      margin: auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      z-index: -1;
    }
    .search {
      position: absolute;
      top: 0px;
      right: 10px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
    .gongge {
      position: absolute;
      top: 0px;
      right: 54px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
  }
  .body {
    margin: 10px 7px;
    margin-top: 54px;
    .search {
      .search_content {
        display: flex;
        flex-wrap: wrap;
        .item_small {
          width: 194px;
          .img {
            width: 194px;
            height: 194px;
            img {
              object-fit: cover;
            }
          }
        }
        .item_big {
          width: 328px;
          .img {
            height: 328px;
            img {
              object-fit: cover;
            }
          }
        }
        .item {
          border-radius: 4px;
          background: #ffffff;
          margin-right: 8px;
          margin-bottom: 8px;
          overflow: hidden;
          border-radius: 4px;
          .img {
            background: #000;
            background-size: contain;
            img {
              height: 100%;
              position: relative;
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .message {
            padding: 9px 10px;
            color: #3e210e;
            // font-style: PingFangSC-Semibold;
            // width:405px;
            background: rgba(255, 255, 255, 1);
            .des {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              p {
                font-size: 10px;
                margin: 5px 0;
              }
            }
          }
        }
      }
    }
    .nosearch {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #333;
      font-size: 20px;
      span {
        color: #f44;
        display: inline-block;
        padding: 0px 5px;
      }
    }
  }
}
</style>
